export default "__VITE_ASSET__Cewm6HwJ__"